var map = {
	"./ikonaBrudnopis-OFF.png": "4001",
	"./ikonaBrudnopis-ON.png": "547d",
	"./ikonaCwiczenie-OFF.png": "1963",
	"./ikonaCwiczenie-ON.png": "f33f",
	"./ikonaFilm-OFF.png": "e20f",
	"./ikonaFilm-ON.png": "2587",
	"./ikonaGaleria-OFF.png": "d64a",
	"./ikonaGaleria-ON.png": "4dc3",
	"./ikonaGimp-OFF.png": "a156",
	"./ikonaGimp-ON.png": "541f",
	"./ikonaIrfan-OFF.png": "963c",
	"./ikonaIrfan-ON.png": "0b1d",
	"./ikonaMikrofon-OFF.png": "1d91",
	"./ikonaMikrofon-ON.png": "2145",
	"./ikonaMuzyka-OFF.png": "6ed4",
	"./ikonaMuzyka-ON.png": "fbcc",
	"./ikonaNotatka-OFF.png": "526f",
	"./ikonaNotatka-ON.png": "4f3f",
	"./ikonaNotatnik-OFF.png": "9632",
	"./ikonaNotatnik-ON.png": "5677",
	"./ikonaPaint-OFF.png": "3d0b8",
	"./ikonaPaint-ON.png": "4c03",
	"./ikonaPobierz-OFF.png": "54c6",
	"./ikonaPobierz-ON.png": "c289",
	"./ikonaPrezentacja-OFF.png": "e105",
	"./ikonaPrezentacja-ON.png": "d06e",
	"./ikonaScratch-OFF.png": "9e99",
	"./ikonaScratch-ON.png": "cc77",
	"./ikonaSluchowisko-OFF.png": "0b71",
	"./ikonaSluchowisko-ON.png": "e615",
	"./ikonaStepbystep-OFF.png": "b1ef",
	"./ikonaStepbystep-ON.png": "335f",
	"./ikonaTabela-OFF.png": "c42c",
	"./ikonaTabela-ON.png": "a39e",
	"./ikonaTablice-OFF.png": "fb31",
	"./ikonaTablice-ON.png": "d081",
	"./ikonaTekst-OFF.png": "a454",
	"./ikonaTekst-ON.png": "88d9",
	"./ikonaWWW-OFF.png": "238d",
	"./ikonaWWW-ON.png": "e924",
	"./ikonaZdjecie-OFF.png": "3fe3",
	"./ikonaZdjecie-ON.png": "1bbd",
	"./ikona_cw1-OFF.png": "b15f",
	"./ikona_cw1-ON.png": "83be",
	"./ikona_cw2-OFF.png": "266e",
	"./ikona_cw2-ON.png": "3d02",
	"./ikona_cw3-OFF.png": "5fe9",
	"./ikona_cw3-ON.png": "6402",
	"./ikona_cw4-OFF.png": "b2a2",
	"./ikona_cw4-ON.png": "65d8",
	"./ikona_cw5-OFF.png": "0709",
	"./ikona_cw5-ON.png": "f250",
	"./ikona_cw6-OFF.png": "d518",
	"./ikona_cw6-ON.png": "f153",
	"./ikona_cw7-OFF.png": "c0c8",
	"./ikona_cw7-ON.png": "cf37",
	"./mac_icon.png": "e3ed",
	"./menuPelny-OFF.png": "3c67",
	"./menuPelny-ON.png": "7e83",
	"./menuPomoc-OFF.png": "da19",
	"./menuPomoc-ON.png": "bedc",
	"./menuPowieksz-OFF.png": "0ad0",
	"./menuPowieksz-ON.png": "1838",
	"./menuRysuj-OFF.png": "3048",
	"./menuRysuj-ON.png": "1714",
	"./menuSpis-OFF.png": "655d",
	"./menuSpis-ON.png": "8d45",
	"./nawiDalej-OFF.png": "493b",
	"./nawiDalej-ON.png": "78aa",
	"./nawiKoniec-OFF.png": "1eb5",
	"./nawiKoniec-ON.png": "a427",
	"./nawiPoczatek-OFF.png": "253e",
	"./nawiPoczatek-ON.png": "7123",
	"./nawiWstecz-OFF.png": "db60",
	"./nawiWstecz-ON.png": "5e3f",
	"./powiekszGrafike.png": "3b42",
	"./przybornik_gumka.png": "69c6",
	"./przybornik_kosz.png": "fb11",
	"./przybornik_menuRysuj_ON.png": "d9ab",
	"./przybornik_okrag.png": "6d0f",
	"./przybornik_pedzel.png": "c108",
	"./przybornik_prostokat.png": "b8f1",
	"./przybornik_wielkosc1.png": "edcf",
	"./przybornik_wielkosc2.png": "0ad1",
	"./przybornik_wielkosc3.png": "0041",
	"./przybornik_wielkosc4.png": "e0bb",
	"./przybornik_wielkosc5.png": "a4e6",
	"./przybornik_wielkosc6.png": "4e5e",
	"./przybornik_wielkosc7.png": "0214",
	"./przybornik_wyroznij.png": "4f89",
	"./przybornik_zakoncz.png": "f197",
	"./vue.png": "6b1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7050";